import { render, staticRenderFns } from "./TimesFeedback.vue?vue&type=template&id=821c6bec&scoped=true"
import script from "./TimesFeedback.vue?vue&type=script&lang=js"
export * from "./TimesFeedback.vue?vue&type=script&lang=js"
import style0 from "./TimesFeedback.vue?vue&type=style&index=0&id=821c6bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821c6bec",
  null
  
)

export default component.exports